module.exports = __webpack_public_path__ + "1868e2550c9853a938a6211d196f9dcd.png";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/images/slider_handles.png
// module id = 382
// module chunks = 1